import { useEffect, useState, useRef } from "react";
import { CustomNotification } from "../../../util/CustomNotification";
import * as dashboard from "../../../services/dashboard";
import { useSelector } from "react-redux";
import { RootState } from "../../../appRedux/store";
import { PLCGWStatusData } from "../../../shared/interface/dashboard.interface";
import useValue from "../../../hooks/useValue";

export const usePLCGWStatus = () => {
  /* CONSTANT */

  /* 10 sec short polling */
  const shortPolling = 10000;

  /* STATE */
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const [data, setData] = useState<PLCGWStatusData | null>(null);

  const { value: loading, handleEnableValue: handleEnableLoading, handleDisableValue: handleDisableLoading } = useValue(false);
  const { masterFilters } = useSelector(({ common }: RootState) => common);

  const fetchData = async (customerId: number, locationId: number) => {
    try {
      handleEnableLoading();
      const response = await dashboard.getPLCGWStatusByCustomerAndLocationId(customerId, locationId);
      setData(response?.data);
    } catch (error) {
      CustomNotification.showErrorMessage(error);
    } finally {
      handleDisableLoading();
    }
  };

  /* EFFECT */
  useEffect(() => {
    if (masterFilters?.customerId && masterFilters?.locationId) {
      /* Initial fetch */
      fetchData(masterFilters?.customerId, masterFilters?.locationId);

      /*  Clear any existing interval */
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }

      /* Start interval for subsequent fetches every 10 seconds */
      intervalRef.current = setInterval(() => {
        if (masterFilters?.customerId && masterFilters?.locationId) fetchData(masterFilters?.customerId, masterFilters?.locationId);
      }, shortPolling);
    }

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [masterFilters?.customerId, masterFilters?.locationId]);

  return { data, loading };
};
